import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DEFAULT_NUMBER, ROOM_CODES } from '@whitbread-eos/api';
export function validateRoomOccupancyConditions(adult, child, roomType, cot) {
  return Number.isNaN(Number(adult)) || Number(adult) < DEFAULT_NUMBER || Number(adult) > 2 || Number(adult) > DEFAULT_NUMBER && roomType === ROOM_CODES.single || Number(adult) === DEFAULT_NUMBER && roomType === ROOM_CODES.twin || Number.isNaN(Number(child)) || Number(child) < 0 || Number(child) > 2 || Number(child) === 0 && roomType === ROOM_CODES.family || Number(child) > 0 && roomType !== ROOM_CODES.family || cot !== null && cot !== undefined && (Number.isNaN(Number(cot)) || Number(cot) < 0 || Number(cot) > DEFAULT_NUMBER) || roomType !== ROOM_CODES.single && roomType !== ROOM_CODES.double && roomType !== ROOM_CODES.family && roomType !== ROOM_CODES.twin && roomType !== ROOM_CODES.accessible;
}
var normaliseRoomTypeCodes = value => {
  var _value$split;
  var codes = Array.isArray(value) ? value : (_value$split = value === null || value === void 0 ? void 0 : value.split(',')) !== null && _value$split !== void 0 ? _value$split : [];
  return [...new Set(codes.map(code => code.trim().toUpperCase()).filter(Boolean))];
};
export var hasSameRoomTypeCodes = (left, right) => {
  var leftCodes = normaliseRoomTypeCodes(left);
  var rightCodes = normaliseRoomTypeCodes(right);
  if (!leftCodes.length || !rightCodes.length) {
    return false;
  }
  return rightCodes.every(code => leftCodes.includes(code));
};
export function roomDefaultValueIfError(rooms) {
  var defaultValue = {
    adultsNumber: DEFAULT_NUMBER,
    childrenNumber: 0,
    type: ROOM_CODES.double
  };
  if (rooms.length === 0) {
    return [_objectSpread({}, defaultValue)];
  }
  var hasInvalidValue = rooms.some(room => {
    var _room$type;
    return validateRoomOccupancyConditions(room.adultsNumber.toString(), room.childrenNumber.toString(), (_room$type = room.type) !== null && _room$type !== void 0 ? _room$type : '');
  });
  if (hasInvalidValue) {
    return [_objectSpread({}, defaultValue)];
  }
  return rooms;
}
export var isInnBusinessApp = hostname => {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  return hostname === null || hostname === void 0 ? void 0 : hostname.includes('business');
};